import { Navigate, useParams } from 'react-router-dom-v5-compat';

import DashboardWorkflowsShowRoute from 'dashboard/routes/DashboardWorkflowsShowRoute';

type Params = { workflowId: string; workflowVersionId: string };

const DashboardWorkflowsShowVersionRoute = () => {
  const { workflowId, workflowVersionId } = useParams<Params>() as Params;

  if (workflowVersionId && workflowVersionId.startsWith('wfv_')) {
    return (
      <Navigate to={`/dashboard/workflows/${workflowId}?version=${workflowVersionId}`} replace />
    );
  }

  return <DashboardWorkflowsShowRoute />;
};

export default DashboardWorkflowsShowVersionRoute;
